import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

import {environment} from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class PlansService {
  private chosenPlan: any;

  constructor(private http: HttpClient) {}

  pixRequest(form: any) {
    return this.http.post<any>(`${environment.base_url}/checkout/pix_request`, form);
  }

  creditRequest(form: any) {
    return this.http.post<any>(`${environment.base_url}/checkout/credit_request`, form);
  }

  getChosenPlan(): any {
    return this.chosenPlan;
  }
  setChosenPlan(plan: any) {
    this.chosenPlan = plan;
  }

  parseMonthsToDays(months: number) {
    switch (months) {
      case 12:
        return 365;
      default:
        return months * 30;
    }
  }

  get(): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${environment.base_url}/checkout`);
  }

  processPayment(data: any): Observable<any> {
    return this.http.post(`${environment.base_url}/checkout/process_payment`, data);
  }

  processBoletoPayment(data: any): Observable<any> {
    return this.http.post(`${environment.base_url}/checkout/process_boleto_payment`, data);
  }

  getLastBoletoLink(): Observable<any> {
    return this.http.get(`${environment.base_url}/checkout/get_last_boleto_link`);
  }

  sendReceipt(formData: FormData): Observable<any> {
    return this.http.post(`${environment.base_url}/checkout/send_receipt`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  sendWordsReceipt(formData: FormData): Observable<any> {
    return this.http.post(`${environment.base_url}/checkout/send_words_receipt`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
